module.exports = __webpack_public_path__ + "static/img/MWA.ee78ce92.png";